import { ApiService } from "src/app/services/api.service";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CompanyQuota } from "src/app/models/company-quota";

@Component({
  selector: "app-detailed-quota",
  templateUrl: "./detailed-quota.component.html",
  styleUrls: ["./detailed-quota.component.scss"],
})
export class DetailedQuotaComponent implements OnInit {
  @Input() symbolCode: string;
  company: any;
  companyQuota: CompanyQuota;
  setCode: string;

  constructor(private apiService: ApiService) {
    this.fetchCompany();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.symbolCode != null && changes.symbolCode != null) {
      if (changes.symbolCode.currentValue != changes.symbolCode.previousValue) {
        this.symbolCode = changes.symbolCode.currentValue;
        if (this.symbolCode) {
          this.fetchCompany();
        }
      }
    }
  }

  ngOnInit(): void {}

  fetchCompany() {
    this.apiService.fetchCompany(this.symbolCode).subscribe((res) => {
      this.company = res;
      this.companyQuota = this.company;
    });
  }
  setSymbolCode() {
    if (this.setCode != null) {
      this.symbolCode = this.setCode;
    }
  }
}
